<template>
  <button v-if="onlyButton" class="button is-secondary font-20 font-w-600" style="border-radius: 8px;" @click.prevent="buy"
    :class="{'is-loading': loading_buy}"
    :disabled="loading_buy">
    Beli Kelas Ini - Rp {{ isEmpty(group) ? '0' : numberFormat(group.groupPrice) }}
  </button>
  <empty-data v-else>
    <p class="font-20 font-w-500" style="margin-bottom: 30px;">Anda belum tergabung di kelas ini.</p>

    <button class="button is-secondary font-20 font-w-600" style="border-radius: 8px;" @click.prevent="buy"
      :class="{'is-loading': loading_buy}"
      :disabled="loading_buy">
      Beli Kelas Ini - Rp {{ isEmpty(group) ? '0' : numberFormat(group.groupPrice) }}
    </button>
  </empty-data>
</template>

<script>
import EDLODER_MIXINS from '~/mixins/edlorder'

export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
    onBuySuccess: {
      type: Function,
      default: () => {},
    },
    onlyButton: {
      type: Boolean,
      default: false,
    }
  },

  mixins: [EDLODER_MIXINS],

  methods: {
    buy() {
      this.ga_send_event(this.auth, {
        eventCategory: 'online_course',
        eventAction: 'click_buy_button',
      });
      this.createOrder([this.group.id])
    },

    onCreateOrderSuccess() {
      window.open(this.edlinvoice.invoiceUrl, '_blank')
      this.onBuySuccess()
    }
  }
}
</script>
